const navMobileBuilder = () => {
  const htmlTag = document.querySelector('html')
  const burger = document.querySelector('.js-burger')
  burger.addEventListener('click', () => {
    htmlTag.classList.toggle('--nav-expanded')
  })
}

navMobileBuilder()
